import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../design/Icon';
import { isHebrew } from '../utils/pasuk';

interface LanguageToggleProps {
  className?: string;
}

/** Switches between the two supported school languages (he / en). */
const LanguageToggle: React.FC<LanguageToggleProps> = ({ className = '' }) => {
  const { t, i18n } = useTranslation();
  const next = isHebrew(i18n.language) ? 'en' : 'he';

  const toggle = async (): Promise<void> => {
    try {
      await i18n.changeLanguage(next);
    } catch (err) {
      console.error('[school] changeLanguage failed', err);
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      className={`inline-flex min-h-[40px] items-center gap-1.5 rounded-xl px-3 text-sm font-medium hover:bg-black/5 ${className}`}
      aria-label={t('school_switch_language') ?? ''}
    >
      <Icon name="globe" className="h-4 w-4" />
      {next === 'en' ? 'English' : 'עברית'}
    </button>
  );
};

export default LanguageToggle;
